import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonialsData = [
    {
      text: 'My daughter was struggling with basic Arabic letters. After four months with her tutor, she reads the Quran fluently. The one-on-one attention made the difference.',
      name: 'Sarah Ahmed.',
      info: 'Texas, USA',

    },
    {
      text: "I started as a complete beginner at 35 and worried it was too late for me. My tutor was patient with every mistake, and within six months I'd completed my first Juz with proper Tajweed. Alhamdulillah.",
      name: 'Khalid Alam.',
      info: 'Ontario, Canada',
    },
    {
      text: "Both of my sons take classes here, and having a female tutor option mattered for my daughter too. Scheduling has stayed flexible, and we haven't missed a class in eight months.",
      name: 'Fatima Ridwan.',
      info: 'New York, USA',
    }
  ];

  return (
    <section
      className="testimonials"
      id="testimonials"
      style={{
        '--bg-url': `url('${process.env.PUBLIC_URL}/assets/images/green-bg.png')`
      }}
    >
      <div className="testimonials__container">
        {/* Headings */}
        <div className="testimonials__badge">Real Students, Real Results</div>
        <h2 className="testimonials__title">What Our Students Say About Al Quran Lesson’s Online Quran Classes</h2>
        <p className="testimonials__subtitle">
          Real Students, Real Progress. Every Story Below Is From A Verified Student Of Al Quran Lesson.
        </p>

        {/* Cards Grid */}
        <div className="testimonials__grid">
          {testimonialsData.map((item, index) => (
            <div key={index} className="testimonials__card">
              {/* Quote Icon */}
              <div className="testimonials__quote-icon">
                <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.19 14.75c0 2.62-2.13 4.75-4.75 4.75s-4.75-2.13-4.75-4.75c0-3.6 3.19-7.16 6.84-8.75l.93 1.83C6.73 9.08 5.75 10.75 5.62 12c1.78.11 3.25 1.5 3.25 3.25 0 .28-.03.56-.09.83.68-.45 1.44-1.07 1.93-1.63l.48.3c.01 0 .01 0 0 0zm11 0c0 2.62-2.13 4.75-4.75 4.75s-4.75-2.13-4.75-4.75c0-3.6 3.19-7.16 6.84-8.75l.93 1.83c-2.73 1.25-3.71 2.92-3.84 4.17 1.78.11 3.25 1.5 3.25 3.25 0 .28-.03.56-.09.83.68-.45 1.44-1.07 1.93-1.63l.48.3c.01 0 .01 0 0 0z" />
                </svg>
              </div>

              {/* Testimonial Text */}
              <p className="testimonials__text">{item.text}</p>

              {/* Divider Line */}
              <div className="testimonials__divider"></div>

              {/* Author Details */}
              <div className="testimonials__author">
                <div className="testimonials__author-meta">
                  <span className="testimonials__author-name">{item.name}</span>
                  <span className="testimonials__author-info">{item.info}</span>
                </div>

              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

